VjsAdmin.UserDashboard = (function () {
    const me = {};

    const platformId = $('#usage-stats').attr('data-platform-id');
    const districtJointGuid = $('#usage-stats').attr('data-district-joint-guid');
    const licenseId = $('#usage-stats').attr('data-license-id');
    const userId = $('#usage-stats').attr('data-user-id');

    me.date_range_option = $('#stats-date-range').val();
    me.date_range_from = null;
    me.date_range_to = null;
    me.date_range_from_display = null;
    me.date_range_to_display = null;

    const init = function () {
        const dateRangeForm = $('<div>').html($('#date-range-form-template').html());
        const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

        $continueButton.on('click', (e) => {
            e.preventDefault();

            let errors = false;
            if ($('#date_range_from').val() === '') {
                $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#date_range_to').val() === '') {
                $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
            }

            if (errors) {
                return false;
            }

            if (
                typeof $('#date_range_from').val() !== 'undefined'
                && $('#date_range_from').val() !== null
                && $('#date_range_from').val() !== ''
            ) {
                $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                me.date_range_from = moment($('#date_range_from').val()).utc().format();
                me.date_range_from_display = moment($('#date_range_from').val()).utc().format('MM/DD/YYYY');
            }
            if (
                typeof $('#date_range_to').val() !== 'undefined'
                && $('#date_range_to').val() !== null
                && $('#date_range_to').val() !== ''
            ) {
                $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                me.date_range_to = moment($('#date_range_to').val()).utc().format();
                me.date_range_to_display = moment($('#date_range_to').val()).utc().format('MM/DD/YYYY');
            }

            $('#stats-date-range option[value="custom"]').html(
                `Custom Date Range &nbsp;&nbsp;&nbsp;&nbsp; (${SafeDOM.escapeHtml(me.date_range_from_display)} to ${SafeDOM.escapeHtml(me.date_range_to_display)})`,
            );

            // refresh the stats
            loadStats();

            $dateRangeModal.modal('hide');

            return true;
        });

        const $dateRangeModal = VjsAdmin.Modal.create({
            id: 'include-usage-modal',
            title: 'Choose Date Range for Usage Stats',
            body: dateRangeForm,
            footer: $continueButton,
            onShown() {
                VjsAdmin.initDateRangePickers($('#include-usage-modal'));
            },
        });

        const loadStats = function () {
            $('.usage-stat').html('<span class="heavy-blur">###</span>');
            $.ajax({
                url: Slim.Router.pathFor('platforms.districts.licenses.users.usage.json', {
                    platform_id: platformId,
                    district_joint_guid: districtJointGuid,
                    license_id: licenseId,
                    user_id: userId,
                }),
                data: {
                    date_range_option: me.date_range_option,
                    date_range_from: me.date_range_from,
                    date_range_to: me.date_range_to,
                },
                dataType: 'json',
                method: 'POST',
                async: true,
            }).done((responseData, textStatus, jqXHR) => {
                $.each(jqXHR.responseJSON.data, (field, value) => {
                    if ($(`#stats-${field}`).length) {
                        setTimeout(() => {
                            $(`#stats-${field}`).text(value);
                        }, Math.floor(Math.random() * 1000));
                    }
                });
            });
        };

        $('#stats-date-range').on('change', function () {
            me.date_range_option = $(this).val();

            if (me.date_range_option === 'custom') {
                $dateRangeModal.modal({
                    backdrop: 'static',
                    keyboard: false,
                });
            } else {
                loadStats();
            }
        });

        loadStats();
    };

    return {
        init,
    };
}());
